<template>
  <svg
    viewBox="0 0 100 100"
    fill="currentColor"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs id="defs2">
      <rect
        x="250.79126"
        y="214.76845"
        width="56.07234"
        height="52.799167"
        id="rect48936"
      />
      <rect
        x="15.490413"
        y="111.00322"
        width="350.84729"
        height="184.83944"
        id="rect20472"
      />
      <rect
        x="300.12529"
        y="256.30014"
        width="227.87716"
        height="104.28723"
        id="rect17658"
      />
      <rect
        x="-28.410837"
        y="-4.0632668"
        width="66.688255"
        height="66.37188"
        id="rect10834"
      />
      <rect
        x="158.79657"
        y="293.34528"
        width="219.88065"
        height="115.61718"
        id="rect19580"
      />
      <rect
        x="359.60889"
        y="344.80322"
        width="24.093756"
        height="44.820198"
        id="rect18174"
      />
      <rect
        x="120.71063"
        y="243.73225"
        width="355.55743"
        height="258.40393"
        id="rect4108"
      />
    </defs>
    <g inkscape:label="Layer 1" inkscape:groupmode="layer" id="layer1">
      <text
        xml:space="preserve"
        transform="scale(0.26458333)"
        id="text4106"
        style="
          font-style: normal;
          font-weight: normal;
          font-size: 40px;
          line-height: 1.25;
          font-family: sans-serif;
          letter-spacing: 0px;
          word-spacing: 0px;
          white-space: pre;
          shape-inside: url(#rect4108);
          stroke: none;
        "
      />
      <text
        xml:space="preserve"
        style="
          font-style: normal;
          font-variant: normal;
          font-weight: 600;
          font-stretch: normal;
          font-size: 10.5833px;
          line-height: 1.25;
          font-family: 'Bodoni Moda 9pt';
          -inkscape-font-specification: 'Bodoni Moda 9pt, Semi-Bold';
          font-variant-ligatures: normal;
          font-variant-caps: normal;
          font-variant-numeric: normal;
          font-variant-east-asian: normal;
          letter-spacing: 0px;
          word-spacing: 0px;
          white-space: pre;
          inline-size: 26.0299;
          stroke: none;
          stroke-width: 0.264583;
        "
        x="70.691254"
        y="92.407066"
        id="text4862"
        transform="matrix(10.433498,0,0,11.721332,-723.41826,-915.94684)"
      />
      <text
        xml:space="preserve"
        transform="scale(0.26458333)"
        id="text18172"
        style="
          font-style: normal;
          font-weight: normal;
          font-size: 40px;
          line-height: 1.25;
          font-family: sans-serif;
          letter-spacing: 0px;
          word-spacing: 0px;
          white-space: pre;
          shape-inside: url(#rect18174);
          stroke: none;
        "
      />
      <text
        xml:space="preserve"
        transform="scale(0.26458333)"
        id="text19578"
        style="
          font-style: normal;
          font-weight: normal;
          font-size: 40px;
          line-height: 1.25;
          font-family: sans-serif;
          letter-spacing: 0px;
          word-spacing: 0px;
          white-space: pre;
          shape-inside: url(#rect19580);
          stroke: none;
        "
      />
      <text
        xml:space="preserve"
        transform="scale(0.26458333)"
        id="text10832"
        style="
          font-style: normal;
          font-weight: normal;
          font-size: 40px;
          line-height: 1.25;
          font-family: sans-serif;
          letter-spacing: 0px;
          word-spacing: 0px;
          white-space: pre;
          shape-inside: url(#rect10834);
        "
      />
      <text
        xml:space="preserve"
        transform="scale(0.26458333)"
        id="text17656"
        stroke="currentColor"
        style="
          font-family: sans-serif;
          font-style: normal;
          font-weight: normal;
          font-size: 40px;
          line-height: 1.25;
          letter-spacing: 0px;
          word-spacing: 0px;
          white-space: pre;
          shape-inside: url(#rect17658);
        "
      />
      <text
        xml:space="preserve"
        transform="scale(0.26458333)"
        id="text20470"
        stroke="currentColor"
        style="
          font-family: sans-serif;
          font-style: normal;
          font-weight: normal;
          font-size: 40px;
          line-height: 1.25;
          letter-spacing: 0px;
          word-spacing: 0px;
          white-space: pre;
          shape-inside: url(#rect20472);
        "
      />
      <text
        xml:space="preserve"
        style="
          font-style: normal;
          font-weight: normal;
          font-size: 10.5833px;
          line-height: 1.25;
          font-family: sans-serif;
          letter-spacing: 0px;
          word-spacing: 0px;
          white-space: pre;
          inline-size: 19.5395;
          stroke-width: 0.264583;
        "
        x="61.075699"
        y="55.044182"
        id="text21226"
      />
      <g
        id="g46790"
        transform="matrix(8.7415347,0,0,9.4194034,-533.69259,-455.21579)"
        inkscape:transform-center-x="-1.6555611"
        inkscape:transform-center-y="6.0823678"
      >
        <text
          xml:space="preserve"
          style="
            font-style: normal;
            font-weight: normal;
            font-size: 10.5833px;
            line-height: 1.25;
            font-family: sans-serif;
            letter-spacing: 0px;
            word-spacing: 0px;
            stroke: none;
            stroke-width: 0.264583;
          "
          x="58.578098"
          y="56.066135"
          id="text31794"
        >
          <tspan
            sodipodi:role="line"
            id="tspan31792"
            style="
              font-style: normal;
              font-variant: normal;
              font-weight: 600;
              font-stretch: normal;
              font-size: 10.5833px;
              font-family: 'Bodoni Moda 9pt';
              -inkscape-font-specification: 'Bodoni Moda 9pt, Semi-Bold';
              font-variant-ligatures: normal;
              font-variant-caps: normal;
              font-variant-numeric: normal;
              font-variant-east-asian: normal;
              stroke-width: 0.264583;
            "
            x="58.578098"
            y="56.066135"
          >
            -r--
          </tspan>
        </text>
      </g>
      <text
        xml:space="preserve"
        transform="scale(0.26458333)"
        id="text48934"
        stroke="currentColor"
        style="
          font-family: sans-serif;
          font-style: normal;
          font-weight: normal;
          font-size: 40px;
          line-height: 1.25;
          letter-spacing: 0px;
          word-spacing: 0px;
          white-space: pre;
          shape-inside: url(#rect48936);
        "
      />
    </g>
  </svg>
</template>
